import styled from 'styled-components'
import { Input } from '@at/design-system-elements'
import { IconIntelligence } from '@at/design-system-icons'

export const StyledAiSearchMain = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 100%;
`
export const StyledAiSearchQueryContainer = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 1em;
`
export const StyledQueryInput = styled(Input)`
    flex-grow: 1;
    max-width: 600px;
`

export const StyledIconIntelligenceSpin = styled(IconIntelligence)`
    color: grey;
    display: inline-block;
    mask: linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/350% 100%;
    animation: shimmer 2.5s infinite;
    font-size: 50px;
    max-width: 200px;

    @keyframes shimmer {
        100% {
            mask-position: left;
        }
    }
`

export const StyledSearchResultsIFrame = styled.iframe`
    width: 100%;
    height: 100vh;
    position: static;
    left: 0;
    border: none;
`
